import {
  Box, MenuItem, Select, Checkbox, ListItemText,
  OutlinedInput, Divider,
  styled,
  Paper
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import { GroupItem } from "../../../types/groupItem";
import { useTranslation } from "react-i18next";
import { GeneralButton } from "../../../common/ui/GeneralButton";

interface MultiSelectGroupsProps {
  selectedGroupIds: number[];
  handleUpdate: (selectedIds: number[]) => void;
  groupList: GroupItem[];
}

const MultiSelectGroups: FC<MultiSelectGroupsProps> = ({
  selectedGroupIds,
  handleUpdate,
  groupList,
}) => {
  const { t } = useTranslation();
  const [tempSelected, setTempSelected] = useState<number[]>(selectedGroupIds);
  const [groupSelectOpen, setGroupSelectOpen] = useState(false);

  useEffect(() => {
    setTempSelected(selectedGroupIds);
  }, [selectedGroupIds]);

  const handleSelectChange = (event: any) => {
    const { value } = event.target;
    setTempSelected(typeof value === "string" ? value.split(",").map(Number) : value);
  };

  const applyChanges = () => {
    handleUpdate(tempSelected);
    setGroupSelectOpen(false);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Select
        multiple
        open={groupSelectOpen}
        value={tempSelected}
        onChange={handleSelectChange}
        input={<OutlinedInput />}
        onOpen={() => setGroupSelectOpen(true)}
        onClose={() => setGroupSelectOpen(false)}
        renderValue={(selected) =>
          groupList
            .filter((group) => selected.includes(group.id))
            .map((group) => group.name)
            .join(", ")
        }
        sx={{
          width: "100%",
          ".MuiSelect-select": { padding: "9px" },
        }}
        MenuProps={{
          PaperProps: {
            component: StyledMenuPaper
          }
        }}
      >
        {groupList.map((group) => (
          <MenuItem key={group.id} value={group.id}>
            <Checkbox checked={tempSelected.includes(group.id)} />
            <ListItemText primary={group.name} />
          </MenuItem>
        ))}

        <Divider />
        <Box className="apply-footer">
          <GeneralButton
            appVariant="primary"
            onClick={applyChanges}
          >
            {t("buttons.apply")}
          </GeneralButton>
        </Box>
      </Select>
    </Box>
  );
};

const StyledMenuPaper = styled(Paper)(({ theme }) => ({
  maxHeight: 400,
  display: "flex",
  flexDirection: "column",

  "& .apply-footer": {
    position: "sticky",
    bottom: 0,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
    display: "flex",
    justifyContent: "flex-end",
    borderTop: `1px solid ${theme.palette.divider}`,
    zIndex: 1,
  },
}));

export default MultiSelectGroups;
